import { useTranslation } from 'react-i18next'
import WifiOffIcon from '@mui/icons-material/WifiOff'
import { Box, Typography } from '@mui/material'

import useOnlineStatus from '@/hooks/useOnlineStatus'

const OfflineBanner: React.FC = () => {
  const isOnline = useOnlineStatus()
  const { t } = useTranslation('', { keyPrefix: 'offline' })

  if (isOnline) return null

  return (
    <Box
      data-testid={'offline-banner'}
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: (theme) => theme.zIndex.snackbar + 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        py: 0.75,
        px: 2,
        backgroundColor: 'warning.main',
        color: 'warning.contrastText',
      }}
    >
      <WifiOffIcon fontSize={'small'} />
      <Typography variant={'body2'}>{t('banner')}</Typography>
    </Box>
  )
}

export default OfflineBanner
